import React from "react";
import { Paper, Typography, Divider, Grid, Chip } from "@mui/material";

const ViewTestKit = ({ kit }) => {
  if (!kit) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Test Kit Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" color="primary">
            {kit.kitName}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {kit.image && (
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <img
                src={kit.image}
                alt={kit.kitName}
                style={{
                  maxWidth: "100%",
                  maxHeight: "300px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          )}
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" color="textSecondary">
            <strong>Description:</strong>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {kit.description}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" color="textSecondary">
            <strong>Price:</strong>
          </Typography>
          <Typography variant="h6" color="primary">
            ${kit.price?.toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" color="textSecondary">
            <strong>Expected Turn Around Time:</strong>
          </Typography>
          <Typography variant="body1">
            {kit.expectedTurnAroundTime} days
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" color="textSecondary">
            <strong>Status:</strong>
          </Typography>
          <Chip
            label={kit.isActive ? "Active" : "Inactive"}
            color={kit.isActive ? "success" : "default"}
            size="small"
            sx={{ mt: 0.5 }}
          />
        </Grid>
       
      </Grid>
    </Paper>
  );
};

export default ViewTestKit;